export enum PaymentPageLinkDialogType {
  ADD = 'ADD',
  EDIT = 'EDIT'
}
